export type AuthTokens = {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
};

const LS_KEY = 'lk_meet_auth';

function safeParse(json: string): unknown {
  try {
    return JSON.parse(json);
  } catch {
    return undefined;
  }
}

export function getTokens(): AuthTokens | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(LS_KEY);
  if (!raw) return null;
  const parsed = safeParse(raw) as Partial<AuthTokens> | undefined;
  if (!parsed) return null;
  if (!parsed.accessToken || !parsed.refreshToken || typeof parsed.expiresAt !== 'number') return null;
  return {
    accessToken: parsed.accessToken,
    refreshToken: parsed.refreshToken,
    expiresAt: parsed.expiresAt,
  };
}

export function setTokens(tokens: AuthTokens) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(LS_KEY, JSON.stringify(tokens));
}

export function clearTokens() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(LS_KEY);
}

export function isAccessExpired(tokens: AuthTokens, skewMs = 15_000): boolean {
  return Date.now() + skewMs >= tokens.expiresAt;
}

